module.exports = __webpack_public_path__ + "static/img/qrcode_offcn.c72edda.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/qrcode_offcn.png
// module id = /rVQ
// module chunks = 6